import { useMemo } from 'react'
import {
  useNavigate,
  useLocation,
  useParams as useRRParams,
  useSearchParams as useRRSearchParams,
} from 'react-router-dom'

export function useRouter() {
  const navigate = useNavigate()
  return useMemo(
    () => ({
      push: (href: string, opts?: { scroll?: boolean; state?: unknown }) => {
        navigate(href, opts?.state !== undefined ? { state: opts.state } : undefined)
      },
      replace: (href: string) => {
        navigate(href, { replace: true })
      },
      prefetch: async () => {},
      back: () => navigate(-1),
      forward: () => navigate(1),
      refresh: () => {
        window.location.reload()
      },
    }),
    [navigate],
  )
}

export function usePathname(): string {
  return useLocation().pathname
}

export function useParams<
  T extends Record<string, string | undefined> = Record<
    string,
    string | undefined
  >,
>() {
  return useRRParams() as T
}

export function useSearchParams(): URLSearchParams {
  const [sp] = useRRSearchParams()
  return sp
}

/** Client-side hard redirect (replaces SSR `redirect()` from the old stack). */
export function redirect(url: string): never {
  window.location.replace(url)
  throw new Error('redirect')
}
